import "./TextBlock.css"

const TextBlock = ({ children }: { children: JSX.Element }) => {

    return (<div className="textBlock">{children}</div>)
}

export default TextBlock;